import { render, staticRenderFns } from "./checkbox-secondary.vue?vue&type=template&id=449aeddd&scoped=true"
import script from "./checkbox-secondary.vue?vue&type=script&lang=js"
export * from "./checkbox-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449aeddd",
  null
  
)

export default component.exports